import React, { ReactNode } from 'react';
import { useTabs } from './TabsProvider';

interface TabContentProps {
  id: string;
  children: ReactNode;
}

export const TabContent = ({ id, children }: TabContentProps) => {
  const { activeTab } = useTabs();
  if (activeTab === id) return <>{children}</>;
  return null;
};
